"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._buildContext = exports.SetVisitationRegister = void 0;
const types_1 = require("./types");
function executionOrderSort(a, b) {
    const _a = a.executionOrder || 0;
    const _b = b.executionOrder || 0;
    return _a - _b;
}
class SetVisitationRegister {
    constructor() {
        this.seenObjects = new Set();
    }
    objectHasBeenSeen(node) {
        return this.seenObjects.has(node.val);
    }
    registerObjectVisit(node) {
        this.seenObjects.add(node.val);
    }
}
exports.SetVisitationRegister = SetVisitationRegister;
function buildDefaultContext(config) {
    var _c, _d, _e, _f, _g, _h;
    return {
        callbacksByPosition: {
            preVisit: [],
            postVisit: []
        },
        config: {
            trackExecutedCallbacks: true,
            visitationRegister: config.visitationRegister || new SetVisitationRegister(),
            traversalMode: (_c = config.traversalMode) !== null && _c !== void 0 ? _c : 'depth',
            graphMode: (_d = config.graphMode) !== null && _d !== void 0 ? _d : 'finiteTree',
            parallelizeAsyncCallbacks: (_e = config.parallelizeAsyncCallbacks) !== null && _e !== void 0 ? _e : false,
            onVisit: (_h = (_g = (0, types_1.asMany)((_f = config.onVisit) !== null && _f !== void 0 ? _f : [])) === null || _g === void 0 ? void 0 : _g.filter(cb => !!cb.callback).map(cb => {
                var _c, _d;
                return ({
                    callback: cb.callback,
                    executionOrder: (_c = cb.executionOrder) !== null && _c !== void 0 ? _c : 0,
                    filters: typeof cb.filters === 'undefined' ? [] : (0, types_1.asMany)(cb.filters),
                    timing: (_d = cb.timing) !== null && _d !== void 0 ? _d : 'preVisit'
                });
            })) !== null && _h !== void 0 ? _h : []
        },
    };
}
function _buildContext(config) {
    const ctx = buildDefaultContext(config);
    (0, types_1.asMany)(ctx.config.onVisit).forEach((cb) => {
        if (cb.timing === "both") {
            ctx.callbacksByPosition.preVisit.push(cb);
            ctx.callbacksByPosition.postVisit.push(cb);
        }
        else
            ctx.callbacksByPosition[cb.timing].push(cb);
    });
    for (const key in ctx.callbacksByPosition)
        ctx.callbacksByPosition[key] = ctx.callbacksByPosition[key].sort(executionOrderSort);
    return ctx;
}
exports._buildContext = _buildContext;
